export const icons = [
  'add',
  'block',
  'arrow_drop_down',
  'calendar_today',
  'check',
  'close',
  'co2',
  'dashboard',
  'finance',
  'flag',
  'lock',
  'lock_person',
  'more_horiz',
  'paid',
  'account_circle',
  'progress_activity',
  'schedule',
  'settings',
  'unfold_less',
  'unfold_more',
  'visibility',
  'visibility_off',
  'warning',
  'chevron_right',
  'groups',
] as const;

const Icon = ({
  name,
  className,
  size,
  style,
}: {
  name: (typeof icons)[number];
  className?: string;
  size?: 'small';
  style?: React.CSSProperties;
}) => (
  <span
    className={`material-symbols-rounded${size === 'small' ? ' icon-small' : ''}${className ? ` ${className}` : ''}`}
    style={style}
  >
    {name}
  </span>
);

export default Icon;
